import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/57/thumb-landscape.jpg"

const Post57 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">LOEWE／アナグラムカットアウトトートスモール／32 x 26 x 11cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
            こんにちは！ファッションが大好きな皆さん、夏の準備は進んでいますか？<br></br>
            今年の夏にぴったりの<span className="text-font-bolder" style={{display: "inline", fontSize: "1.6rem"}}>【ロエベの「アナグラム カットアウトバッグ」】</span>を、今日はご紹介します。<br></br><br></br>
            太陽がキラキラ輝くこの季節、いつものコーデに何か新しい「スパイス」が欲しいと思っている方も多いのではないでしょうか。<br></br><br></br>
            そんなあなたにおすすめしたいのが、LOEWE（ロエベ）から登場した<span className="text-font-bolder" style={{display: "inline", fontSize: "1.6rem"}}>「アナグラムカットアウト バッグ」</span>です。<br></br><br></br>
            「ロエベ？」「アナグラム？」「カットアウト？」と、少し聞き慣れないかもしれませんが、この記事を読めば、このバッグがどれほど特別で、あなたの夏スタイルをぐっとおしゃれに変えてくれるのかがきっとわかるはずです。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;ロエベってどんなブランド？ちょっとだけおさらい</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;「アナグラムカットアウト」って何がすごいの？</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;「あのロゴ」がまさかの変身！</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec4" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;職人の手仕事が魅せる『くり抜き』――カットアウトデザイン</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec5" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;「革のツヤ」触れてわかる、最高級のこだわり</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;このバッグ、どうやって持つのがおしゃれ？夏のスタイリング術</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec8" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;いつものカジュアルが、一瞬で垢抜ける！</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec9" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;リゾートで、みんなと差をつけるなら</ScrollLink><br></br>    
            <ScrollLink className="scroll text-indent" to="sec10" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;お仕事シーンでも、さりげなくセンスアップ</ScrollLink><br></br>    
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec11" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;私にぴったりの「アナグラムカットアウト」を見つけよう！</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec12" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;「アナグラムカットアウトのサイズと容量の選び方」</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec13" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;「アナグラムカットアウトのカラー選び｜夏におすすめカラーは？」</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec14" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;まとめ：この夏、あなただけの特別なバッグを！</ScrollLink><br></br>
          </div>
        </p>
      </div>         
      <div name="sec1" className="text-max-width">
        <h1>ロエベってどんなブランド？ちょっとだけおさらい</h1>
      </div>
      <p className="text-max-width">
        ロエベは、なんと170年以上も前にスペインで生まれた、とっても歴史のあるブランドなんです。<br></br>
        元々は革製品を作る工房からスタートして、最高級の革を扱う職人さんたちが集まっていました。だから、ロエベのバッグや小物は、革の質が本当に素晴らしいことで有名です。<br></br>
        最近では、ジョナサン・アンダーソンという、とってもクリエイティブなデザイナーさんがロエベの舵を取るようになってから、伝統を守りつつも、まるでアート作品のような、遊び心あふれるアイテムをたくさん生み出しています。
      </p>
      <p className="text-max-width">今回ご紹介する「アナグラムカットアウト」も、まさにそんなロエベの「伝統」と「新しい挑戦」がギュッと詰まった、特別なバッグとなります。</p>     
      <figure>
        <StaticImage src="../../images/posts/57/1.jpg" alt=""/>
      </figure>    
      <div name="sec2" className="text-max-width">
        <h1>「アナグラムカットアウト」って何がすごいの？</h1>
      </div>
      <p className="text-max-width">さあ、いよいよ本題です！この「アナグラムカットアウト」バッグ、一目見たら忘れられない、とってもユニークなデザインが魅力です。</p>
      <div name="sec3" className="text-max-width">
        <h2><span className="text-border-bottom text-color-gray">◆ 「あのロゴ」がまさかの変身！</span></h2>
      </div>
      <p className="text-max-width">ロエベのアイテムを見たことがある人なら、きっと「L」の文字がいくつか組み合わさった、あの特徴的なロゴマークを覚えているはず。そう、あれが「アナグラム」です。ロエベの顔とも言えるとっても大切なシンボル。この「アナグラムカットアウト」バッグでは、なんとそのおなじみのアナグラムが革に直接「くり抜かれて」いるんです！普通、ロゴって描いたり金具でつけたりしますよね？</p>
      <p className="text-max-width">
        でも、このバッグは違うんです。<br></br>
        ロゴの形に革が切り抜かれているから、バッグの向こう側が透けて見えるような、とっても面白いデザインになっています。光の当たり方や、バッグの中に入れたものの色によって、ロゴの表情が変わり、まるで生きているみたいに見るたびに新しい発見があります。
      </p>
      <p className="text-max-width">これって、まるでアート作品みたいだと思いませんか？</p>
      <div name="sec4" className="text-max-width">
        <h2><span className="text-border-bottom text-color-gray">◆ 職人の手仕事が魅せる『くり抜き』――カットアウトデザイン</span></h2>
      </div>
      <p className="text-max-width">「くり抜き」って聞くと、ちょっと安っぽく聞こえるかもしれませんが、そこはさすがロエベ！ただ穴を開けただけじゃないんです。この「カットアウト」デザインは、ロエベの職人さんがミリ単位で計算して、とっても丁寧に切り抜いていています。だから、切り口がすごく滑らかで、まるで最初からこの形だったかのように、バッグ全体に一体感があります。</p>
      <p className="text-max-width">このくり抜かれた部分から、バッグの裏地や、ちょっとだけ中に入れたポーチなどがチラッと見えるのが、またおしゃれポイント！「中に何が入ってるんだろう？」って、見る人の想像力をかき立てる、遊び心満載のデザインです。</p>
      <p className="text-max-width">直線と曲線が組み合わさったデザインは、まるで建築物みたいに立体的で美しくシンプルなコーディネートに合わせるだけで、一瞬で「あれ、なんか今日のファッション、すごく洗練されてる！」って印象に変わります。</p>
      <p className="text-max-width">夏の軽やかな服装にはもちろん、秋冬のちょっと重めなスタイルにも、抜け感とアートな雰囲気をプラスしてくれる、まさに魔法のバッグです。</p>
      <div name="sec5" className="text-max-width">
        <h2><span className="text-border-bottom text-color-gray">◆ 「革のツヤ」触れてわかる、最高級のこだわり</span></h2>
      </div>
      <p className="text-max-width">ロエベといえば、やっぱり「革」！このアナグラムカットアウトバッグも、もちろん最高級の革が使われています。触ってみると、とっても柔らかいです。でも、ただ柔らかいだけじゃなくて、しっかりとした丈夫さも兼ね備えているから、長く愛用できます。使い込むほどに、手に馴染んで、革のツヤも増していく…そんな変化も楽しめます。</p>
      <p className="text-max-width">こんなに繊細な「くり抜き」のデザインを、これほどまでに美しく仕上げるには、本当にすごい技術が必要です。レーザーで精密にカットする技術と、それをさらに人の手で丁寧に仕上げる職人さんの技が合わさって、この特別なバッグは生まれています。</p>
      <p className="text-max-width space-bottom">「細部に神は宿る」なんて言いますが、まさにロエベの職人さんの魂が、このバッグの一つ一つに込められているんですね。だから、ただの流行りものじゃなくて、何十年も大切にしたい「名品」として、とても価値があります。</p>
      <figure name="sec7">
        <StaticImage src="../../images/posts/57/2.jpg" alt=""/>
      </figure>    
      <div className="text-max-width">
        <h1>このバッグ、どうやって持つのがおしゃれ？夏のスタイリング術</h1>
      </div>
      <p className="text-max-width" style={{marginBottom: "6rem"}}>「アナグラムカットアウト」バッグは、そのユニークなデザインだからこそ、どんなスタイルにも新鮮な風を吹き込んでくれます。夏のいろんなシーンで、このバッグがどう活躍するか、具体的に見ていきましょう！</p>
      <figure name="sec8">
        <StaticImage src="../../images/posts/57/3.jpg" alt=""/>
        <span className="text-center">LOEWE／アナグラムカットアウトトートスモール／32 x 26 x 11cm</span>
      </figure>  
      <h2><span className="text-border-bottom text-color-gray">◆ いつものカジュアルが、一瞬で垢抜ける！</span></h2>
      <p className="text-max-width">主役は、ブラウンのレザーで象られたロエベの「アナグラムカットアウトトートスモール」。中の白いライニングが透けて見え、軽やかな印象を与えています。</p>
      <p className="text-max-width">これに合わせたのは、ナチュラルなベージュカラーのワイドレッグパンツと、抜け感を演出する黒のキルティングサンダル。</p>
      <p className="text-max-width">トップスはバッグの色味とリンクしたブラウンのニットタンクトップで、全体に統一感のあるアースカラーのトーンでまとめられています。</p>
      <p className="text-max-width">さらに、黒のバケットハットと丸いフレームのサングラスが、スタイリングにこなれ感と日差し対策をプラス。</p>
      <p className="text-max-width space-bottom">休日にカフェ巡りに行ったり、友達とランチしたり、そんなリラックスしたシーンでこそ、このバッグの存在感がキラリと光ります。上質なアイテムを軸に、無理なくおしゃれを楽しめる、大人のサマースタイルが完成。</p> 
      <figure name="sec9">
        <StaticImage src="../../images/posts/57/4.jpg" alt=""/>
        <span className="text-center">LOEWE／アナグラム カットアウトポケット／11 x 20 x 8cm</span>
      </figure>  
      <h2><span className="text-border-bottom text-color-gray">◆ リゾートで、みんなと差をつけるなら</span></h2>
      <p className="text-max-width">
        夏のリゾートシーンにぴったりの、上品で涼しげなコーディネート。<br></br>
        ネイビー地に白い柄が散りばめられたベアトップのワンピース。デコルテラインを美しく見せ、リゾート地の開放感を演出します。
      </p>
      <p className="text-max-width">足元には、すっきりとしたホワイトのストラップサンダルを合わせ、軽やかな印象をプラス。</p>
      <p className="text-max-width">小物使いも秀逸で、ロエベの白い「アナグラム カットアウトポケット」が、透かし彫りのデザインで夏の抜け感を演出し、コーディネートにリュクスなアクセントを加えています。</p>
      <p className="text-max-width">広いつばの麦わら帽子とサングラスは、日差し対策にもなりつつ、リゾートムードを盛り上げる必須アイテム。さらに、存在感のあるシルバーのバングルと小ぶりなピアスが、洗練された大人の女性らしさを添えています。</p>
      <p className="text-max-width space-bottom">全体的に爽やかな色合いでまとめられ、都会的でありながらも肩の力が抜けた、大人のためのバカンススタイルが完成。</p> 
      <figure name="sec10">
        <StaticImage src="../../images/posts/57/5.jpg" alt=""/>
        <span className="text-center">LOEWE／アナグラムカットアウトトートスモール／32 x 26 x 11cm</span>
      </figure>  
      <h2><span className="text-border-bottom text-color-gray">◆ オフィスカジュアルにも◎さりげなくセンスアップ</span></h2>
      <p className="text-max-width">「こんなに個性的なバッグ、お仕事にはどうかな？」って思うかもしれませんね。でも、ご安心ください！その上品な佇まいから、ビジネスシーンにも意外なほどマッチします。</p>
      <p className="text-max-width">
        清潔感のあるシャツとデニムをベースにした、オフィスカジュアル。<br></br>
        中心となるのは、「アナグラムカットアウトトートスモール」。
      </p>
      <p className="text-max-width">トップスは肌馴染みの良いホワイトベージュのシャツをセレクト。</p>
      <p className="text-max-width">ボトムスはライトブルーのロールアップデニムで抜け感を演出。</p>
      <p className="text-max-width">足元には、コーディネート全体をぐっと格上げする爽やかなミントブルーのパンプスを合わせ、女性らしいエレガントさをプラス。</p> 
      <p className="text-max-width space-bottom">ブラウンのレザーベルトの腕時計が、バッグの色味とリンクしつつ、知的で上品な雰囲気を添えています。かっちりしすぎず、程よくトレンド感と遊び心を取り入れた、好感度の高い大人女性のオフィスカジュアルスタイルの完成。</p> 
      <figure name="sec8">
        <StaticImage src="../../images/posts/57/6.jpg" alt=""/>
        <span className="text-center">LOEWE／アナグラム カット アウトポケット／11 x 20 x 8cm</span>
      </figure>   
      <div name="sec11" className="text-max-width">
        <h1>私にぴったりの「アナグラムカットアウト」を見つけよう！</h1>
      </div>
      <p className="text-max-width space-bottom">
        「アナグラムカットアウト」は、見た目の美しさはもちろん、<span className="text-font-bolder">サイズ感や容量、カラーの選び方</span>で自分らしさをしっかり楽しめるのが魅力です。
        アクセサリー感覚で持てる小さめサイズにするか、普段使いに頼れるサイズで容量を重視するか――季節に映えるおすすめカラーを選ぶのも、おしゃれの楽しみのひとつ。
        あなただけの「特別なひとつ」をぜひ見つけてくださいね。
      </p>
      <div name="sec12" className="text-max-width">
        <h2><span className="text-border-bottom text-color-gray">◆ 「アナグラムカットアウトのサイズと容量の選び方」</span></h2>
      </div>  
      <div className="text-max-width">
        <h2><span className="text-font-bolder">・アナグラム カットアウトポケット　11 x 20 x 8cm</span></h2>
      </div>  
      <div className="text-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/57/7.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-background-gray">こんな人におすすめ☝️</span></p>
          <p>
            <span className="text-font-bolder">☑️&nbsp;荷物はできるだけコンパクトにしたい人</span><br></br>
            スマホ・ミニ財布・鍵・リップだけで出かけたい、ミニマル派にぴったり。
          </p> 
          <p>
            <span className="text-font-bolder">☑️&nbsp;おしゃれなサブバッグを探している人</span><br></br>
            旅行先やショッピングで大きなバッグとは別に“アクセサリー感覚”で使いたい人に。
          </p> 
          <p>
            <span className="text-font-bolder">☑️&nbsp;パーティーやイベントでも使える小さめバッグが欲しい人</span><br></br>
            華やかすぎず程よく上品だからワンピースやきれいめドレスにも合わせやすい。
          </p>
          <p>
            <span className="text-font-bolder">☑️&nbsp;とにかく軽いバッグを探している人</span><br></br>
            斜め掛けで手ぶらになれるので、子ども連れのちょっとした外出にも便利。
          </p>
        </div>
      </div>
      <div className="text-max-width">
        <h2><span className="text-font-bolder">・アナグラムカットアウトトートスモール　32 x 26 x 11cm</span></h2>
      </div>
      <div className="text-img-cloumn-main space-bottom">
        <figure>
          <StaticImage src="../../images/posts/57/8.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-background-gray">こんな人におすすめ☝️</span></p>
          <p>
            <span className="text-font-bolder">☑️&nbsp;荷物がそこそこ多いけど大きすぎるバッグは苦手な人</span><br></br>
            長財布・ポーチなど、必要なものはしっかり入れたい人にぴったり。
          </p>
          <p>
            <span className="text-font-bolder">☑️&nbsp;通勤と休日、どちらも使えるきちんと感が欲しい人</span><br></br>
            オンオフ兼用できるので、毎日のバッグを一つに絞りたい人におすすめ。
          </p>
          <p>
            <span className="text-font-bolder">☑️&nbsp;肩掛けも手持ちもできるデザインを探している人</span><br></br>
            両手を空けたい日も、きれいめに持ちたい日も、シーンを選ばず活躍。
          </p>
          <p>
            <span className="text-font-bolder">☑️&nbsp;「ザ・ロエベ」を感じる存在感のあるトートが欲しい人</span><br></br>
            ブランドらしさをしっかり楽しみたい人に最適。
          </p>
        </div>
      </div>
      <figure>
          <StaticImage src="../../images/posts/57/9.jpg" alt=""/>
        </figure>
      <div name="sec13" className="text-max-width">
        <h2><span className="text-border-bottom text-color-gray">◆ 「アナグラムカットアウトのカラー選び｜夏におすすめカラーは？」</span></h2>
      </div>  
      <p className="text-max-width space-bottom">
        ロエベ「アナグラム カットアウトポケット」と「アナグラム カットアウトトートスモール」の、<br></br>
        夏におすすめのカラー選びのポイントを、それぞれの色が引き立つコーデの雰囲気や印象と一緒にわかりやすくお伝えします。
      </p>
      <div className="text-max-width">
        <h2><span className="text-font-bolder">・アナグラムカットアウトトートスモール／32 x 26 x 11cm</span></h2>
      </div>
      <div className="text-img-cloumn-main space-bottom">
        <figure>
          <StaticImage src="../../images/posts/57/10.jpg" alt=""/>
        </figure>
        <div>
          <p>【ブラック】</p>
          <p>
            仕事や日常使いに万能。<br></br>
            夏の薄い色の服に合わせてもカットアウトのおかげで重く見えず、程よく引き締まるのが魅力。<br></br>
            大きめのサイズ感でもブラックなら高級感が引き立ちます。
          </p> 
          <p>
            <p><span className="text-background-gray">こんな人におすすめ☝️</span></p>
            ☑️&nbsp;おしゃれなサブバッグを探している人<br></br>
            ☑️&nbsp;パーティーやイベントでも使える小さめバッグが欲しい人<br></br>
            ☑️&nbsp;とにかく軽いバッグを探している人
          </p> 
        </div>  
      </div>
      <div className="text-img-cloumn-main space-bottom">
        <figure>
          <StaticImage src="../../images/posts/57/11.jpg" alt=""/>
        </figure>
        <div>
          <p>【タン（キャメル系）】</p>
          <p>
            ロエベらしさが最も感じられる定番カラー。<br></br>
            夏の白シャツ、リネン、デニムなど自然素材との相性が抜群で、シーズン問わず使える万能カラーです。<br></br>
            日差しに当たると柔らかい革の色味がより立体的に。
          </p> 
          <p>
            <span className="text-background-gray">こんな人におすすめ☝️</span><br></br>
            ☑️&nbsp;自然体で品よく見せたい人<br></br>
            ☑️&nbsp;カジュアルにもキレイめにも合わせたい人<br></br>
            ☑️&nbsp;「ザ・ロエベ」を楽しみたい人◎
          </p> 
        </div>
      </div>
      <div className="text-max-width">
        <h2><span className="text-font-bolder">・アナグラムカットアウトポケット／11 x 20 x 8cm</span></h2>
      </div>
      <div className="text-img-cloumn-main space-bottom">
        <figure>
          <StaticImage src="../../images/posts/57/12.jpg" alt=""/>
        </figure>
        <div>
          <p>【ブラック】</p>
          <p>
            夏のモノトーンコーデに最適。<br></br>
            白シャツやリネンパンツなどの軽い装いを引き締めてくれるので、クールで都会的な印象に。<br></br>
            黒でもカットアウトがあるから重く見えず透け感が涼しげに映えます。
          </p> 
          <p>
            <span className="text-background-gray">こんな人におすすめ☝️</span><br></br>
            ☑️&nbsp;夏でも黒を楽しみたい人<br></br>
            ☑️&nbsp;シンプルモノトーン派<br></br>
            ☑️&nbsp;きちんと感を残したい人
          </p> 
        </div>  
      </div>
      <div className="text-img-cloumn-main space-bottom">
        <figure>
          <StaticImage src="../../images/posts/57/13.jpg" alt=""/>
        </figure>
        <div>
          <p>【ブラウン】</p>
          <p>
            ナチュラルカラーのリネンコーデに相性抜群。<br></br>
            キャメルやブラウンは太陽光の下で柔らかく見え、リゾート感や大人のリラックス感を演出してくれます。
          </p> 
          <p>
            <span className="text-background-gray">こんな人におすすめ☝️</span><br></br>
            ☑️&nbsp;ベージュ系やアースカラーが多い人<br></br>
            ☑️&nbsp;大人カジュアル派<br></br>
            ☑️&nbsp;リゾートワンピや麦わら帽子に合わせたい人
          </p> 
        </div>  
      </div>
      <div className="text-img-cloumn-main space-bottom">
        <figure>
          <StaticImage src="../../images/posts/57/14.jpg" alt=""/>
        </figure>
        <div>
          <p>【ホワイト】</p>
          <p>
            夏らしさNo.1！<br></br>
            レザーの上質さで品があり、爽やかさとクリーンさを両立できます。<br></br>
            白T、白シャツ、デニムと合わせて“抜け感”を楽しんで。
          </p> 
          <p>
            <span className="text-background-gray">こんな人におすすめ☝️</span><br></br>
            ☑️&nbsp;オールホワイトコーデが好きな人<br></br>
            ☑️&nbsp;夏の軽やかさを最大限楽しみたい人<br></br>
            ☑️&nbsp;涼しげでクリーンな雰囲気が好きな人
          </p> 
        </div>  
      </div>
      <div className="text-img-cloumn-main space-bottom">
        <figure>
          <StaticImage src="../../images/posts/57/15.jpg" alt=""/>
        </figure>
        <div>
          <p>【ブルー】</p>
          <p>
            淡いブルーは夏の日差しに映える爽やかカラー。<br></br>
            デニムやホワイトコーデに合わせると、程よい差し色になりつつも大人っぽさをキープ。
          </p> 
          <p>
            <span className="text-background-gray">こんな人におすすめ☝️</span><br></br>
            ☑️&nbsp;カジュアル派<br></br>
            ☑️&nbsp;夏にさりげなく色を入れたい人<br></br>
            ☑️&nbsp;デニムスタイルが多い人
          </p> 
        </div>  
      </div>
      <div className="text-img-cloumn-main space-bottom">
        <figure>
          <StaticImage src="../../images/posts/57/16.jpg" alt=""/>
        </figure>
        <div style={{width: "80%"}}>
          <p>【パープル】</p>
          <p>
            少しモードで女性らしい印象。<br></br>
            ピンクほど甘くなく、上品さとアクセントを両立できるので、無地ワンピやブラックコーデに合わせるとこなれ感が出ます。
          </p> 
          <p>
            <span className="text-background-gray">こんな人におすすめ☝️</span><br></br>
            ☑️&nbsp;ちょっと人と差をつけたい人<br></br>
            ☑️&nbsp;フェミニン派だけど甘すぎないものが欲しい人<br></br>
            ☑️&nbsp;ブラックやホワイトにワンポイント色を足したい人
          </p> 
        </div>  
      </div>
      <div name="sec13" className="text-max-width">
        <h2><span className="text-border-bottom text-font-bolder">カラー総まとめ</span></h2>
      </div>  
      <p>☀️ さわやかに抜け感を楽しむなら → ホワイト・ブルー</p>
      <p>☀️ ナチュラルに大人カジュアルなら → ブラウン・タン</p>
      <p>☀️ モード＆クールに都会的に → ブラック</p>
      <p>☀️ ワンポイントで女性らしく → パープル</p>
      <div name="sec14" className="text-max-width">
        <h1>まとめ：この夏、あなただけの特別なバッグを！</h1>
      </div>
      <p className="text-max-width">
        いかがでしたでしょうか？<br></br>
        LOEWEの「アナグラムカットアウト」は、遊び心と個性を添える、まさに「身につけるアート」です。
      </p>
      <p className="text-max-width">この夏、ワードローブに新しい風を吹き込みたいとお考えなら、ぜひこの<span className="text-font-bolder">「アナグラムカットアウト」</span>をチェックしてみてください。持つ人の感性を刺激し、日常をより豊かに彩ってくれるはず。</p>
      <p className="text-max-width">光を味方につけたロエベのアナグラムカットアウトが、特別な輝きを放つことを願って。</p>
      <div className="border"></div> 
      <p className="text-max-width">📱憧れを日常に──ラクサスでロエベを体験しよう！</p>     
      <Link to="https://laxus.co/app/pc/bags/loewe" className="view-all-button">
        ロエベのバッグはこちら
      </Link>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post57

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 57}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`